var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictures"},[_vm._m(0),_c('div',{staticClass:"body"},[_c('PicList')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top orangeToYellow"},[_c('span',[_vm._v("摄像头图片")])])
}]

export { render, staticRenderFns }